export default function initTopCatchphrase() {
    const catchphrase = document.querySelector('.js-catchphrase');
    if (!catchphrase) return;

    const catchphraseLines = catchphrase.querySelectorAll('.js-catchphrase-line');

    // 1. 全体で1つのTimelineを作成（最初は止めておく）
    const mainTl = gsap.timeline({ paused: true });

    catchphraseLines.forEach((line, index) => {
        const text = line.querySelector('.js-catchphrase-text');
        const belt = line.querySelector('.js-catchphrase-belt');
        const startOffset = index * 0.4; // 0.4秒ずつずらして開始

        mainTl
            .fromTo(belt, { scaleX: 0 }, { scaleX: 1, duration: 0.7, ease: 'power2.inOut' }, startOffset)
            .set(text, { opacity: 1 })
            .call(() => {
                const clonedBelt = belt.cloneNode(true);
                clonedBelt.classList.add('p-about-us__catchphrase-belt-clone');
                belt.insertAdjacentElement('afterend', clonedBelt);
                belt.remove();
                clonedBelt.style.transformOrigin = 'right center';

                // 続きのアニメーションも同じ時間軸で管理
                gsap.to(clonedBelt, { scaleX: 0, duration: 0.7, ease: 'power2.inOut' });
            });
    });

    // 2. IntersectionObserverで発火タイミングを監視
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                mainTl.play();
                observer.unobserve(entry.target); // 1回きり
            }
        });
    }, {
        rootMargin: '0px 0px -25% 0px' // 少し見えてから発火
    });

    observer.observe(catchphrase);
}